<template>
  <div id="form-psoriasis" class="row card-collapse form-psoriasis" v-if="loading === false">
    <titan-form ref="formApplicationType"
                :schema="schemaApplicationType"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :on-form-update="onFormUpdate"
                :render-in-card="true"
                :show-action-button="false"
    />
    <titan-form :schema="additionalDoctorInfo"
                v-if="showAdditionalDoctorInfoForm"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :show-action-button="false"
    />
    <patient-form ref="patientForm"
                  @saveData="saveData()"
                  @validate="isValid()"
                  :formData="formData.patient"
                  :editable="hasPermission('ApplicationsTitan', 'U') && !accepted"
                  :show-action-button="false"
    />
    <titan-form ref="formApplicationStart"
                v-if="showStartForm"
                :schema="schemaApplicationStart"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :newItem="$route.name === 'createPatient'"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :on-form-update="onFormUpdate"
                :show-action-button="false"
    />
    <titan-form ref="formApplicationContinuation"
                v-if="showContinueForm"
                :schema="schemaApplicationContinuation"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :newItem="$route.name === 'createPatient'"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :on-form-update="onFormUpdate"
                :show-action-button="false"
    />
    <titan-form ref="formApplicationTermination"
                v-if="showTerminateForm"
                :schema="schemaApplicationTermination"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :newItem="$route.name === 'createPatient'"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :on-form-update="onFormUpdate"
                :show-action-button="false"
    />
    <div class="col-12 card-collapse">
      <div class="card" v-if="loadedAttachments">
        <div class="card-header">{{t('Attachments')}}</div>
        <div class="card-body row">
          <div class="col-6">
            <!--            <file-upload @addedFile="loadAttachmentsData()"-->
            <!--                         :api-url="uploadFileUrl"-->
            <!--                         :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"-->
            <!--            />-->
            <file-upload-with-encryption
              @addedFile="loadAttachmentsData()"
              :multiple="true"
              :api-url="uploadEncryptedFileUrl"
              :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"
            />
            <div class="mt-2" v-if="formData.applicationsAttachments.length === 0">
              {{t('Files were not attached to applications')}}
            </div>
          </div>
          <div class="col-6">
              <a :href="file.link"
                 :key="file.id"
                 :download="file.isClientEncrypted ? file.decryptedFilename : file.file"
                 v-for="file in formData.applicationsAttachments"
                 class="row file-row"
                 target="_blank"
              >
                <div class="col col-lg-2 file-col-image">
                  <img :src="file.link" :alt="file.file"
                       v-if="['jpg', 'png', 'gif'].includes(file.format)">
                  <div class="file-icon" v-if="!(['jpg', 'png', 'gif'].includes(file.format))">
                    <font-awesome-icon icon="file"/>
                  </div>
                </div>
                <div class="col col-lg-10">
                  <div class="h3 mb-0">{{ file.isClientEncrypted ? file.decryptedFilename : file.name  }}</div>
                  <small>{{file.size | prettyBytes}}</small>
                </div>
              </a>
          </div>
        </div>
      </div>
    </div>
    <div id="main-save" class="main-save " :class="scrolledToBottom ? 'non-fixed':'fixed'">
      <b-button v-on:click="$emit('saveData')" variant="primary">{{t('Save')}}</b-button>
    </div>
  </div>

</template>

<script>
    import TitanForm from '../../../core/Form/Form'
    import FileUpload from './file-upload'
    import FileUploadWithEncryption from './file-upload-with-encryption'
    import VueFormGenerator from 'vue-form-generator';
    import {validateMultipleForms} from '../../../core/Libs/utils';
    import EpicrisisPattern from './epicrisis-pattern';
    import {apiLink} from '../../../store/api'
    import TimeLine from '../../../core/TimeLine';
    import AcceptAction from '../../../core/AcceptAction';
    import FormGenerator from '../../../core/Form/vfg/formGenerator';
    import FieldRadios from 'vue-form-generator';
    import PatientForm from '../patients/form';
    import {get, set} from 'lodash';

    export default {
        components: {
            AcceptAction,
            TimeLine,
            EpicrisisPattern,
            TitanForm,
            FileUpload,
            PatientForm,
            FieldRadios,
            FileUploadWithEncryption,
            'vue-form-generator': FormGenerator,
        },
        props: {
            formData: {
                type: Object,
                required: true,
            },
            accepted: {
                type: Boolean,
                default: true,
            }
        },
        created() {
            //this.positionActionPanel();
            window.addEventListener('scroll', this.positionActionPanel);
            window.addEventListener('resize', this.positionActionPanel);

        },
        mounted() {
            setTimeout(() => {
                this.scrolledToBottom = false;
                this.resizeActionPanel();
                this.loadedAttachments = true;
            }, 50)
            let f = this.getFields(this.schemaApplicationStart);
            f.forEach(field => {
                if (typeof field.showIf === 'string') {
                    let mainFieldModel = field.showIf;
                    let mainField = this.getFormField(this.schemaApplicationStart, mainFieldModel);
                    let mainFieldVal = mainField.model.split('.').reduce((o, i) => o[i], this.formData);
                    let sc = field.styleClasses.replace('invisible', '');
                    if (mainFieldVal === false) {
                        field.styleClasses = sc + ' invisible';
                        field.required = false;
                    } else {
                        field.styleClasses = sc;
                        field.required = true;
                    }
                }
            });
        },
        watch: {
            insuranceCode(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 50)
                }
            }
        },
        computed: {
            uploadFileUrl() {
                return apiLink() + 'applications/upload-file/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            uploadEncryptedFileUrl() {
                return apiLink() + 'applications/upload-file-encrypted/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            insuranceCode() {
                return !this.formData.patient.insurance ? null : this.formData.patient.insurance.code;
            },
            showContinueForm() {
                return this.formData.applicationType === 'other';
            },
            showTerminateForm() {
                return this.formData.applicationType === 'end';
            },
            showAdditionalDoctorInfoForm() {
                return (this.doctorRole ? [1, 2].includes(this.doctorRole) : false);
            },
            showStartForm() {
                return this.formData.applicationType === 'first';
            },
            treatmentRecommend() {
                return this.formData.applicationContent.treatmentRepeatYn === 1;
            },
            doctorRole() {
                return this.formData.applicationContent.addDocRole;
            }
        },
        methods: {
            resizeActionPanel() {
                let el = document.querySelector('#form-psoriasis');
                if (el) {
                    let bb = el.getBoundingClientRect();
                    let width = bb.right - bb.left;
                    document.getElementById('main-save').style.width = width + 'px';

                }
            },
            positionActionPanel() {
                setTimeout(() => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + (window.innerHeight + 125) > document.documentElement.offsetHeight
                    if (bottomOfWindow) {
                        this.scrolledToBottom = true;

                    } else {
                        this.resizeActionPanel();
                        this.scrolledToBottom = false;
                    }
                }, 100)
            },
            index(obj, i) {
                return obj[i]
            },
            eraseHiddenValues() {
                this.getFields().forEach(field => {
                        if (typeof field.showIf === 'string') {
                            let isHidden = field.styleClasses.search('invisible') >= 0;
                            if (isHidden) {
                                set(this.formData, field.model, null);
                            }
                        }
                    }
                );
            },
            isValid() {
                this.eraseHiddenValues();
                return validateMultipleForms([
                    this.$refs.formApplicationType,
                    this.$refs.formApplicationStart,
                    this.$refs.formApplicationContinuation
                ])
            },
            getFormField(schema, fieldModelName) {
                let foundField = null;
                schema.forEach((form) => {
                    form.groups.forEach((group) => {
                        group.fields.forEach((field) => {
                            if (field.model === fieldModelName) {
                                foundField = field;
                            }
                        });
                    });
                });
                return foundField;
            },
            getFields(schema, formIndex = null) {
                let fields = [];
                for (let [index, form] of Object.entries(this.$data)) {
                    if (formIndex === null || index === formIndex) {
                        if (Array.isArray(form)) {
                            form = form[0];
                            if (form.hasOwnProperty('fields')) {
                                form.fields.forEach(item => {
                                    fields.push(item);
                                })
                            } else if (form.hasOwnProperty('groups')) {
                                form.groups.forEach(groupItem => {
                                    groupItem.fields.forEach(item => {
                                        fields.push(item);
                                    });
                                });
                            }
                        }
                    }
                }
                ;
                return fields;
            },
            loadAttachmentsData() {
                this.$store.dispatch('applications/attachments', this.$route.params.id);
            },
        },
        data() {
            return {
                scrolledToBottom: false,
                onFormUpdate: (newVal, changedModel) => {
                    if (newVal !== null) {
                        if (changedModel.indexOf('Yn') >= 0) {
                            this.getFields(this.schemaApplicationStart).forEach(field => {
                                if (typeof field.showIf === 'string' && field.showIf === changedModel) {
                                    let sc = field.styleClasses.replace('invisible', '');
                                    if (newVal === false) {
                                        field.styleClasses = sc + ' invisible';
                                        field.required = false;
                                    } else {
                                        field.styleClasses = sc;
                                        field.required = true;
                                    }
                                }
                            });
                        }
                    }

                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: false
                },
                loading: false,
                loadedAttachments: false,
                schemaApplicationType: [
                    {
                        name: this.t('Application type'),
                        type: 'main',
                        fields: [
                            {
                                type: 'radios',
                                label: this.t('Application type'),
                                styleClasses: 'col-12 radios-float',
                                model: 'applicationType',
                                values: [
                                    {value: 'first', name: this.t('The beginning')},
                                    {value: 'other', name: this.t('Continuing')},
                                    {value: 'end', name: this.t('Termination')}
                                ],
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            },
                            {
                                type: 'radios',
                                label: this.t('My role in application'),
                                styleClasses: 'col-12 radios-float',
                                model: 'applicationContent.addDocRole',
                                values: [
                                    {value: 1, name: this.t('Indicating physician')},
                                    {value: 2, name: this.t('Attending physician')},
                                    {value: 3, name: this.t('Both attending and indicating physician')},
                                ],
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }
                        ]
                    }
                ],
                schemaApplicationStart: [
                    {
                        name: this.t('Treatment start'),
                        type: 'main',
                        groups: [
                            {
                                legend: this.t('Diagnosis and therapy'),
                                styleClasses: 'diagnosis-and-therapy',
                                fields: [
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('Diagnosis name'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosis',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        values: (string) => {
                                            return this.$store.dispatch('indications/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        },
                                    },
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('MKCH10'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosisCode',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        selected: (item) => {
                                            this.formData.diagnosisCode = item.code;
                                        },
                                        valueLabel: (item) => {
                                            return item.code + ' - ' + item.name;
                                        },
                                        values: (string) => {
                                            return this.$store.dispatch('diseaseClassification/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        }
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis set date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.diagnosisSetDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis start date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.treatmentStartDate',
                                        language: this.$i18n.locale,
                                        required: true,
                                        validator: VueFormGenerator.validators.required
                                    },
                                    {
                                        type: 'titanSelect',
                                        label: this.t('Drug'),
                                        styleClasses: 'col-12',
                                        model: 'drug',
                                        codeBook: 'drugs',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        }
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Requested packages'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqPackages',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period from'),
                                        model: 'applicationContent.drugReqFrom',
                                        styleClasses: 'col-3',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period to'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqTo',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Dosage'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqDosage',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Previous treatment'),
                                styleClasses: 'previous-treatment',
                                fields: [
                                    {
                                        type: 'label',
                                        label: this.t('Drug'),
                                        styleClasses: 'col-2'
                                    },
                                    {
                                        type: 'label',
                                        label: this.t('Drug name'),
                                        styleClasses: 'col-3'
                                    },
                                    {
                                        type: 'label',
                                        label: this.t('Treatment start date'),
                                        styleClasses: 'col-2'
                                    },
                                    {
                                        type: 'label',
                                        label: this.t('Treatment end date'),
                                        styleClasses: 'col-2'
                                    },
                                    {
                                        type: 'label',
                                        label: this.t('Treatment termination reason'),
                                        styleClasses: 'col-3'
                                    },
                                    {
                                        type: 'titanSwitch',
                                        label: '1.',
                                        styleClasses: 'col-2 left-float',
                                        model: 'applicationContent.prevTreat1DrugYn',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        //DRUG 1
                                        type: 'titanSelect',
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.prevTreat1DrugId',
                                        codeBook: 'drugs',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        visible: false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat1DrugName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat1DrugYn'
                                    },
                                    {

                                        type: 'titanDatePicker',
                                        model: 'applicationContent.prevTreat1DateStart',
                                        styleClasses: 'col-2 invisible',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat1DrugYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.prevTreat1DateEnd',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat1DrugYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat1EndReason',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat1DrugYn'
                                    },
                                    {
                                        type: 'titanSwitch',
                                        label: '2.',
                                        styleClasses: 'col-2 left-float',
                                        model: 'applicationContent.prevTreat2DrugYn',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        //DRUG 2
                                        type: 'titanSelect',
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.prevTreat2DrugId',
                                        codeBook: 'drugs',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        visible: false

                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat2DrugName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat2DrugYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.prevTreat2DateStart',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat2DrugYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.prevTreat2DateEnd',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat2DrugYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat2EndReason',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat2DrugYn'
                                    },
                                    {
                                        type: 'titanSwitch',
                                        label: '3.',
                                        styleClasses: 'col-2 left-float',
                                        model: 'applicationContent.prevTreat3DrugYn',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        //DRUG 3
                                        type: 'titanSelect',
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.prevTreat3DrugId',
                                        codeBook: 'drugs',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        visible: false

                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat3DrugName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat3DrugYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.prevTreat3DateStart',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat3DrugYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.prevTreat3DateEnd',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat3DrugYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.prevTreat3EndReason',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.prevTreat3DrugYn'
                                    },
                                ]
                            },
                            {
                                legend: this.t('Family history'),
                                styleClasses: 'family-history',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        styleClasses: 'col-12',
                                        max: 150,
                                        label: this.t('General description'),
                                        model: 'applicationContent.histFmlGeneral',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'family-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Malignous disease'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.histFmlMalignousYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Consequence'),
                                        styleClasses: 'col-9',
                                        model: 'applicationContent.histFmlMalignousCons',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histFmlMalignousYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'family-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('TBC'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.histFmlTbcYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Consequence'),
                                        styleClasses: 'col-9 invisible',
                                        model: 'applicationContent.histFmlTbcCons',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histFmlTbcYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'family-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Other serious disease'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.histFmlOtherYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Please specify'),
                                        styleClasses: 'col-4 invisible',
                                        model: 'applicationContent.histFmlOtherName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histFmlOtherYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Consequence'),
                                        styleClasses: 'col-5 invisible',
                                        model: 'applicationContent.histFmlOtherCons',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histFmlOtherYn'
                                    },
                                ]
                            },
                            {
                                legend: this.t('Personal history'),
                                styleClasses: 'personal-history',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('General description'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.histPrsnlGeneral',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Lymphoproliferative process'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlLymfoYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlLymfoDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlLymfoYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlLymfoTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlLymfoYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Hematologic disease'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlHemaYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlHemaDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlHemaYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlHemaTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlHemaYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Serious cardiovascular disease'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlCardioYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlCardioDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlCardioYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlCardioTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlCardioYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Serious infectious disease'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlInfectiousYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlInfectiousDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlInfectiousYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlInfectiousTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlInfectiousYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Confirmed contact with TBC in last 3 months'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlTbcYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlTbcDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlTbcYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('TBC type'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlTbcType',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlTbcYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('TBC localisation'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlTbcLocal',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlTbcYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Hepatitis'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlHepaYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlHepaDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlHepaYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlHepaTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlHepaYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Other infectious disease in last 3 months'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlInfectiousRecentYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Please specify'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlInfectiousRecentName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlInfectiousRecentYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlInfectiousRecentDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlInfectiousRecentYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlInfectiousRecentTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlInfectiousRecentYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Autoimmune disease'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlAutoimmuneYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlAutoimmuneDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlAutoimmuneYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlAutoimmuneTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlAutoimmuneYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Diabetes mellitus'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlDiabetesYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlDiabetesDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlDiabetesYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlDiabetesTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlDiabetesYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Serious neurologic disease'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlNeuroYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlNeuroDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlNeuroYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-6 invisible',
                                        model: 'applicationContent.histPrsnlNeuroTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlNeuroYn'
                                    },
                                ]
                            },
                            {
                                legend: null,
                                styleClasses: 'personal-history grid-subform',
                                fields: [
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Other malignity'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.histPrsnlOtherYn',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Please specify'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlOtherName',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlOtherYn'
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Date diagnosed'),
                                        styleClasses: 'col-2 invisible',
                                        model: 'applicationContent.histPrsnlOtherDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlOtherYn'
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Treatment'),
                                        styleClasses: 'col-3 invisible',
                                        model: 'applicationContent.histPrsnlOtherTreat',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.histPrsnlOtherYn'
                                    },
                                ]
                            },
                            {
                                legend: this.t('Examination results'),
                                styleClasses: 'examination-results',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('FW'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.examBaseFw',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('CRP'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.examBaseCrp',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },

                                ]
                            },
                            {
                                legend: this.t('Lab examination results'),
                                styleClasses: 'lab-examination-results',
                                fields: [
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Lab tests date'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.labDate',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('HbsAg'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labHbsAg',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('AntiHIV'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labAntihiv',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('TPHA'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labTpha',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('antiHCV'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labAntihcv',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                ]
                            },
                            {
                                legend: this.t('Hematological parameters'),
                                styleClasses: 'hematological parameters',
                                fields: []
                            },

                            {
                                legend: this.t('KO'),
                                styleClasses: 'ko',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Hb') + ' (g/d)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaKoHb',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Ht'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaKoHt',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Ery') + '  (x10<sup>12</sup>/l)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaKoEry',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Leu') + '  (x10<sup>12</sup>/l)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaKoLeu',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Trmb') + '  (x10<sup>9</sup>/l)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaKoTrmb',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },

                                ]
                            },
                            {
                                legend: this.t('Dif KO'),
                                styleClasses: 'dif-ko',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Neutrophils') + ' (%)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaDifNeutro',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Eosinophils') + ' (%)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaDifEozino',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Basophils') + ' (%)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaDifBazo',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Monocytes') + ' (%)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaDifMono',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Lymphocytes') + ' (%)',
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.labHemaDifLymfo',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Biochemical parameters'),
                                styleClasses: 'biochemical-parameters',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Glycemia') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioGlycemia',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Bilirubin') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioBilirubin',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('AST') + ' (ukat/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioAst',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('ALT') + ' (ukat/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioAlt',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('ALP') + ' (ukat/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioAlp',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('GMT') + ' (ukat/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioGmt',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Proteins total') + ' (g/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioProteinsTotal',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Urea') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioUrea',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Creatinine') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioCreatinine',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Natrium') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioNatrium',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Kalium') + ' (mmol/l)',
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.labBioKalium',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Cholesterol total') + ' (mmol/l)',
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labBioCholesterolTotal',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('TAG') + ' (mmol/l)',
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.labBioTag',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Pulmonary examination'),
                                styleClasses: 'pulmonary-examination',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('General examination conclusion'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.examPneuConclusion',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Chest RTG'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.examPneuRtg',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('IGRA test'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.examPneuIgra',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Mantoux II'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.examPneuMantoux2',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                ]
                            },
                            {
                                legend: this.t('Gynecological and urological examination'),
                                styleClasses: 'gyn-and-uro-examination',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('General examination conclusion'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.examGynConclusion',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Gravidity test'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.examGynGravidity',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Prostate examination'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.examProstate',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanSwitch',
                                        label: this.t('Contraception usage'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.examGynContraceptionYn',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Drug name'),
                                        styleClasses: 'col-9 invisible',
                                        model: 'applicationContent.examGynContraceptionName',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        showIf: 'applicationContent.examGynContraceptionYn'
                                    },

                                ]
                            },
                            {
                                legend: this.t('Other examinations'),
                                styleClasses: 'other-examinations',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Dental examination'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.stomaGeneral',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('ORL examination'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.orlGeneral',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Urine and chemical sediment'),
                                styleClasses: 'urine-and-chemical-sediment',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('pH'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.urinePh',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Ery'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.urineEry',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Leu'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.urineLeu',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Cylinders'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.urineCylinders',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Bacteries'),
                                        styleClasses: 'col-2',
                                        model: 'applicationContent.urineBacteries',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                ]
                            },
                            {
                                legend: this.t('Conclusion'),
                                styleClasses: 'conclusion',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Psoriasis evaluation - PASI before start of treatment'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.psoriasisEvaluation',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Other important information'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.otherInformation',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                        ]
                    },
                ],
                schemaApplicationContinuation: [
                    {
                        name: this.t('Treatment continuation'),
                        type: 'main',
                        groups: [
                            {
                                legend: this.t('Diagnosis and therapy'),
                                styleClasses: 'diagnosis-and-therapy',
                                fields: [
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('Diagnosis name'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosis',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        values: (string) => {
                                            return this.$store.dispatch('indications/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        },
                                    },
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('MKCH10'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosisCode',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        selected: (item) => {
                                            this.formData.diagnosisCode = item.code;
                                        },
                                        valueLabel: (item) => {
                                            return item.code + ' - ' + item.name;
                                        },
                                        values: (string) => {
                                            return this.$store.dispatch('diseaseClassification/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        }
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis set date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.diagnosisSetDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis start date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.treatmentStartDate',
                                        language: this.$i18n.locale,
                                        required: true,
                                        validator: VueFormGenerator.validators.required
                                    },
                                    {
                                        type: 'titanSelect',
                                        label: this.t('Drug'),
                                        styleClasses: 'col-12',
                                        model: 'drug',
                                        codeBook: 'drugs',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        }
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Requested packages'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqPackages',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period from'),
                                        model: 'applicationContent.drugReqFrom',
                                        styleClasses: 'col-3',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period to'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqTo',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Dosage'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqDosage',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Treatment continuation'),
                                styleClasses: 'treatment-termination',
                                fields: [
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Treatment month'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.treatmentMonth',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        hint: this.t('in which month of therapy is the patient')
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('I recommend to continue treatment after'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.treatmentRepeatAfter',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        hint: this.t('enter number of months')
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Number of dosages provided'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.treatmentDosagesProvided',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Updated psoriasis evaluation - PASI'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.psoriasisEvaluationCont',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Treatment effectivness evaluation'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.treatmentEffectivnessEvaluation',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Other important information'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.otherInformationCont',
                                        required: false,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }

                                ]
                            }
                        ]
                    },
                ],
                schemaApplicationTermination: [
                    {
                        name: this.t('Treatment termination'),
                        type: 'main',
                        groups: [
                            {
                                legend: this.t('Diagnosis and therapy'),
                                styleClasses: 'diagnosis-and-therapy',
                                fields: [
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('Diagnosis name'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosis',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        values: (string) => {
                                            return this.$store.dispatch('indications/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        },
                                    },
                                    {
                                        type: 'titanAutocomplete',
                                        label: this.t('MKCH10'),
                                        styleClasses: 'col-6',
                                        model: 'diagnosisCode',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        minStringLength: -1,
                                        selected: (item) => {
                                            this.formData.diagnosisCode = item.code;
                                        },
                                        valueLabel: (item) => {
                                            return item.code + ' - ' + item.name;
                                        },
                                        values: (string) => {
                                            return this.$store.dispatch('diseaseClassification/codeBook', {
                                                page: 1,
                                                conditions: []
                                            });
                                        }
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis set date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.diagnosisSetDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Diagnosis start date'),
                                        styleClasses: 'col-6',
                                        model: 'applicationContent.treatmentStartDate',
                                        language: this.$i18n.locale,
                                        required: true,
                                        validator: VueFormGenerator.validators.required
                                    },
                                    {
                                        type: 'titanSelect',
                                        label: this.t('Drug'),
                                        styleClasses: 'col-12',
                                        model: 'drug',
                                        codeBook: 'drugs',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                        singleLabel: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        },
                                        option: (item) => {
                                            return item.name + '<br><small>' + item.package + '</small>';
                                        }
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Requested packages'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqPackages',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period from'),
                                        model: 'applicationContent.drugReqFrom',
                                        styleClasses: 'col-3',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Period to'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqTo',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'text',
                                        label: this.t('Dosage'),
                                        styleClasses: 'col-3',
                                        model: 'applicationContent.drugReqDosage',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    }
                                ]
                            },
                            {
                                legend: this.t('Treatment termination'),
                                styleClasses: 'treatment-termination',
                                fields: [
                                    {
                                        type: 'textArea',
                                        inputType: 'text',
                                        max: 150,
                                        label: this.t('Treatment termination reason'),
                                        styleClasses: 'col-12',
                                        model: 'applicationContent.treatmentTerminationReason',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        type: 'titanDatePicker',
                                        label: this.t('Treatment termination date'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.treatmentTerminationDate',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                    },
                                    {
                                        type: 'input',
                                        inputType: 'number',
                                        label: this.t('Number of unused dosages'),
                                        styleClasses: 'col-4',
                                        model: 'applicationContent.treatmentDosageLeft',
                                        required: true,
                                        validator: VueFormGenerator.validators.required,
                                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                                    },
                                ]
                            }
                        ]
                    },
                ],
                additionalDoctorInfo: [
                    {
                        name: () => {
                            return (this.doctorRole === 2) ? this.t('Indicating physician') : this.t('Attending physician')
                        },
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Physician code'),
                                styleClasses: 'col-12',
                                model: 'applicationContent.addDocPhysicianCode',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title prefix'),
                                styleClasses: 'col-2',
                                model: 'applicationContent.addDocTitlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Firstname'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocFirstname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Lastname'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocLastname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title sufix'),
                                styleClasses: 'col-2',
                                model: 'applicationContent.addDoctitleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Provider code'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocProviderCode',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Company name') + ' / ' + this.t('Facility name'),
                                styleClasses: 'col-8',
                                model: 'applicationContent.addDocCompanyName',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Street'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocStreet',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('City'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocCity',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('ZIP'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocZip',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('VAC'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocVac'
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Phone'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocPhone',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('E-mail'),
                                styleClasses: 'col-4',
                                model: 'applicationContent.addDocEmail',
                                required: false,
                                validator: VueFormGenerator.validators.email
                            },
                        ]
                    }
                ]

            }
        }
    }
</script>

<style lang="scss">
  .vue-form-generator {
    .grid-subform {
      padding-bottom: 10px;
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;

      &:hover {
        background: #efefef;
        border-bottom: 1px solid #dadada;
        border-top: 1px solid #dadada;
      }

      label span {
        /*display: inline !important;*/
      }

      .field-titanSwitch {

        .field-wrap {
          position: absolute;
          top: 10px;
        }

        label {
          position: absolute;
          top: 10px;
          left: 75px;

          span {
            display: inline;
          }
        }
      }

    }
  }

  .form-psoriasis {
    .file-row {
      margin-left: 0;
      margin-top: 0;
    }

    /*.dropzone {*/
    /*  .dz-message {*/
    /*    margin:0;*/
    /*  }*/
    /*}*/
    .main-save {
      &.fixed {
        /*box-shadow: 0px -3px 2px 1px #efefef;*/
        position: fixed;
        bottom: 0;
        border: 0;
        border-top: 2px solid rgba(0, 0, 0, 0.125);
        border-radius: 0;
      }

      &.non-fixed {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        background: white;

      }

      z-index: 1000;
      background: #efefef;
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border: 1px solid rgba(0, 0, 0, 0.125);
      border-top: 0;
      border-radius: .25rem;
    }

    .form-group.left-float {
      & > label {
        float: left;
        width: 10%;
      }

      .field-wrap {
        float: left;
        margin-left: 0.5rem;
      }
    }

    .form-group.radios-float {
      & > label {
        float: left;
        width: 20%;
      }

      .field-wrap {
        float: left;
        margin-left: 1rem;
      }
    }

    .form-control {
      border-color: #b3b8bd !important;
    }

    .field-label {
      span {
        font-size: 1rem;
      }
    }

    label {
      font-size: 0.9rem;
    }

    legend {
      padding-top: 0.6rem;
      font-size: 1.2rem;
    }

    .titan-select {
      .multiselect__tags {
        border-color: #b3b8bd !important;
      }
    }

    .titan-switch {
      height: 26px;
      line-height: 26px;
      padding-left: 28px !important;
      font-size: 0.9rem;

      &.switch-off {
        background-color: gray !important;
        padding-left: 6px !important;
      }

      &.switch-on {
        background-color: #3ac165 !important;
        padding-right: 5px !important;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/derma-form.vue